/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard'
    },
    {
        id: 'camps',
        title: 'Camps',
        type: 'group',
        icon: 'heroicons_outline:home-modern',
        children: [
            {
                id: 'camps.camp-list',
                title: 'Camp list',
                type: 'basic',
                icon: 'heroicons_outline:academic-cap',
                link: '/camps',
            },
            {
                id: 'camp-category',
                title: 'Camp Category',
                type: 'basic',
                icon: 'heroicons_outline:academic-cap',
                link: '/camp-category',
            },
            {
                id: 'train',
                title: 'Trains',
                type: 'basic',
                icon: 'heroicons_outline:academic-cap',
                link: '/trains',
            },
            {
                id: 'additional-fees',
                title: 'Additional Camps Fees',
                type: 'basic',
                icon: 'heroicons_outline:academic-cap',
                link: '/additional-fees',
            },
        ],
    },
    {
        id: 'participants',
        title: 'Participants',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/participants',
    },
    {
        id: 'inventory',
        title: 'Inventory',
        type: 'group',
        icon: 'heroicons_outline:archive-box',
        children: [
            {
                id: 'inventory.items',
                title: 'Item Master',
                type: 'basic',
                icon: 'heroicons_outline:cube',
                link: '/inventory/items',
            },
            {
                id: 'inventory.outward',
                title: 'Outward (Issue)',
                type: 'basic',
                icon: 'heroicons_outline:arrow-up-tray',
                link: '/inventory/outward',
            },
            {
                id: 'inventory.inward',
                title: 'Inward (Return)',
                type: 'basic',
                icon: 'heroicons_outline:arrow-down-tray',
                link: '/inventory/inward',
            },
            {
                id: 'inventory.payments',
                title: 'Payments',
                type: 'basic',
                icon: 'heroicons_outline:banknotes',
                link: '/inventory/payments',
            },
        ],
    },
    {
        id: 'organizations',
        title: 'Organizations',
        type: 'basic',
        icon: 'heroicons_outline:building-library',
        link: '/organizations',
    },
    {
        id: 'locations',
        title: 'Location',
        type: 'group',
        icon: 'heroicons_outline:map',
        link: '/',
        children: [
            {
                id: 'countries',
                title: 'Countries',
                type: 'basic',
                icon: 'heroicons_outline:flag',
                link: '/countries',
            },
        ],
    },
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'heroicons_outline:user',
        link: '/users',
        children: [],
    },
    {
        id: 'chat',
        title: 'Chat',
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-left-right',
        link: '/chat',
    },
    {
        id: 'camp-registrations',
        title: 'Camp Registrations',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/camp-registrations',
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
        children: [],
    },
    {
        id: 'camps',
        title: 'Camps',
        type: 'group',
        icon: 'heroicons_outline:home-modern',
        children: [
            {
                id: 'camps.camp-list',
                title: 'Camp list',
                type: 'basic',
                icon: 'heroicons_outline:academic-cap',
                link: '/camps',
            },
            {
                id: 'camp-category',
                title: 'Camp Category',
                type: 'basic',
                icon: 'heroicons_outline:academic-cap',
                link: '/camp-category',
            },
            {
                id: 'train',
                title: 'Trains',
                type: 'basic',
                icon: 'heroicons_outline:academic-cap',
                link: '/trains',
            },
            {
                id: 'additional-fees',
                title: 'Additional Camps Fees',
                type: 'basic',
                icon: 'heroicons_outline:academic-cap',
                link: '/additional-fees',
            },
        ],
    },
    {
        id: 'participants',
        title: 'Participants',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/participants',
    },
    {
        id: 'inventory',
        title: 'Inventory',
        type: 'group',
        icon: 'heroicons_outline:archive-box',
        children: [
            {
                id: 'inventory.items',
                title: 'Item Master',
                type: 'basic',
                icon: 'heroicons_outline:cube',
                link: '/inventory/items',
            },
            {
                id: 'inventory.outward',
                title: 'Outward (Issue)',
                type: 'basic',
                icon: 'heroicons_outline:arrow-up-tray',
                link: '/inventory/outward',
            },
            {
                id: 'inventory.inward',
                title: 'Inward (Return)',
                type: 'basic',
                icon: 'heroicons_outline:arrow-down-tray',
                link: '/inventory/inward',
            },
            {
                id: 'inventory.payments',
                title: 'Payments',
                type: 'basic',
                icon: 'heroicons_outline:banknotes',
                link: '/inventory/payments',
            },
        ],
    },
    {
        id: 'organizations',
        title: 'Organizations',
        type: 'basic',
        icon: 'heroicons_outline:building-library',
        link: '/organizations',
    },
    {
        id: 'locations',
        title: 'Location',
        type: 'group',
        icon: 'heroicons_outline:map',
        link: '/',
        children: [
            {
                id: 'countries',
                title: 'Countries',
                type: 'basic',
                icon: 'heroicons_outline:flag',
                link: '/countries',
            },
        ],
    },
    {
        id: 'users',
        title: 'Users',
        type: 'basic',
        icon: 'heroicons_outline:user',
        link: '/users',
        children: [],
    },
    {
        id: 'chat',
        title: 'Chat',
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-left-right',
        link: '/chat',
    },
    {
        id: 'camp-registrations',
        title: 'Camp Registrations',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/camp-registrations',
    },
];
